<div class="message-list" #scrollContainer (scroll)="onScroll()">
  @for (msg of messages; track msg.id; let i = $index) {
    @if (showDateSeparator(i)) {
      <div class="date-separator">
        <span>{{ dateSeparatorLabel(msg) }}</span>
      </div>
    }
    <app-message-bubble
      [message]="msg"
      [isMine]="msg.senderId === currentUserId" />
  }

  <app-typing-indicator [indicators]="typingIndicators" />
</div>
